import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";

const { REACT_APP_GRAPHQL_SERVER_PORT, REACT_APP_GRAPHQL_SERVER_HOST } = process.env;
const graphQLURI = `http://${REACT_APP_GRAPHQL_SERVER_HOST}:${REACT_APP_GRAPHQL_SERVER_PORT}/`;

const client = new ApolloClient({
  uri: graphQLURI,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
